/* ==========================================================================
   Stories Animation
   ========================================================================== */

// ...

import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

var gridBlockGrow = document.querySelectorAll(
  ".stories-grid:nth-of-type(4n+2)"
);
var gridBlockShift = document.querySelectorAll(
  ".stories-grid:nth-of-type(4n+3)"
);

var mediaQuery = window.matchMedia("(min-width: 1024px)");

function imageGrow() {
  gsap.registerPlugin(ScrollTrigger);
  gsap.config({ nullTargetWarn: false });
  const imageGrow = gsap.utils.toArray(gridBlockGrow);
  imageGrow.forEach((img, i) => {
    ScrollTrigger.create({
      trigger: img,
      toggleClass: "grow",
      start: "top +700",
      end: "bottom 20%",
    });
  });
}

function imageShift() {
  gsap.registerPlugin(ScrollTrigger);
  gsap.config({ nullTargetWarn: false });
  const imageShift = gsap.utils.toArray(gridBlockShift);
  imageShift.forEach((img, i) => {
    ScrollTrigger.create({
      trigger: img,
      toggleClass: "shift",
      start: "top +800",
      end: "bottom 20%",
    });
  });
}

if (window.matchMedia("(min-width: 1024px)").matches) {
  window.addEventListener("load", function () {
    imageShift();
    imageGrow();
  });
}
